import { render, staticRenderFns } from "./ProfileGeneralInfo.vue?vue&type=template&id=722657ab&scoped=true&"
import script from "./ProfileGeneralInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfileGeneralInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileGeneralInfo.vue?vue&type=style&index=0&id=722657ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722657ab",
  null
  
)

export default component.exports